import React, {Component} from 'react';
import {Box} from 'reactjs-admin-lte'
import {Button,Form,FormGroup,Col,Row,Modal} from 'react-bootstrap'
import WorkdocStore from 'stores/WorkdocStore'
import FontAwesome from 'react-fontawesome'
import $ from 'jquery'
import {connect} from 'react-redux'
import { Radio } from 'react-icheck'
import DatePicker from 'component/element/DatePicker'
import CkTimePicker from 'component/element/CkTimePicker'
import Select from 'react-select'
import WorkJobAssignTaskModal from '../jobcontrol/WorkJobAssignTaskModal'
import Moment from 'moment'
import { Checkbox } from 'react-icheck'
import SWTProgramPopup from '../SWTProgramModal'
const yTh = parseInt(Moment().format('YYYY')) + 543
var NotificationSystem = require('react-notification-system');

class PMBoardTable extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
  }

  initState(){
    let state = {
      loading:false,
      data:[],
      showAssign:false,
      assignIndex:-1,
      assignSubIndex:-1,
      where_fix:'in',
      symptomlist:[],
      isCheckAll:false,
      showProgram:false
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.loadData()
    $('body').on('click', ()=> { 
      if ($('.Select').hasClass('is-open'))
        $('.table-responsive').css( "overflow-x", "initial" );
      else
        $('.table-responsive').css( "overflow-x", "auto" );
    });
  }

  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps) {
    
  }

  newEmptyRow(number,kindex) {
    let {data} = this.state
    return new Array(number).fill(null).map((item, index) => {
      return {bf_symptom_id: "", bf_task_id: "", bf_work_damage_id: "", contractor_id: "", employee_id: "", first_name: "", last_name: "", leader_first_name: "", leader_id: "", leader_last_name: "", leader_nick_name: "", nick_name: "", remark: "", seq: "", task_value: data[kindex].task_value, taskclosed_date: "", taskstarted_date: "", taskclosed_time: "", taskstarted_time: "", total_cost: "0", work_no: this.props.workNo}
    })
  }

  getToday() {
    return Moment().format('L LT').replace(Moment().format('YYYY'), yTh)
  } 

  loadData() {
    this.setState({loading:true})
    WorkdocStore.loadPMTasklist(this.props.workNo,(result)=>{
      let newdata = []
      let itemlist = result.data.map((item,index)=>{
        item = Object.assign(item,{task_status:''})
        return item
      })
      let task_value = []
      let i = 0
      itemlist.forEach((item,index)=>{
        if (task_value.indexOf(item.task_value)===-1) {
          task_value.push(item.task_value)  
          let tasklist = []
          tasklist.push(item)
          newdata.push({
            number:i+1,
            tasklist:tasklist,
            task_value:item.task_value,
          })
          i++
        } else {
          let newdataIndex = task_value.indexOf(item.task_value)
          newdata[newdataIndex].tasklist.push(item)
        }
      })
      this.setState({loading:false,data:newdata})
    })
  }

  loadSymptom(complete) {
    let {symptomlist} = this.state
    WorkdocStore.loadSymptom(this.props.workNo,(result)=>{
      symptomlist = result.data.map((item,index)=>{
        item = Object.assign(item,{isCheck:false})
        return item
      })
      this.setState({symptomlist:symptomlist,isCheckAll:false},()=>{
        if (complete!==undefined)
          complete()
      })
    })
  }

  onPMFixingTaskSave(task_id,postData,complete) {
    WorkdocStore.savePMFixingTask(task_id,postData,(result)=>{
      if (result.status==='OK') {
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level:'info',
          position:'tc'
        });
        if (complete!==undefined)
          complete(result.bf_task_id)
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำการบันทึกรายการไม่สำเร็จ',
        level:'error',
        position:'tc'
      });
    })
  }

  onTaskStatusChange(index,sindex,e) {
    let {data} = this.state
    data[index].tasklist[sindex].task_status = e.value
    this.setState({data:data},()=>{
      let postData = data[index].tasklist[sindex]
      let task_id = data[index].tasklist[sindex].bf_task_id
      this.onPMFixingTaskSave(task_id,postData)
    })
  }

  onTechnicianEdit(index,sindex) {
    let {data} = this.state
    this.setState({showAssign:true,assignIndex:index,assignSubIndex:sindex})
    let person = {first_name:data[index].tasklist[sindex].first_name,last_name:data[index].tasklist[sindex].last_name,nick_name:data[index].tasklist[sindex].nick_name}
    let leader = {first_name:data[index].tasklist[sindex].leader_first_name,last_name:data[index].tasklist[sindex].leader_last_name,nick_name:data[index].tasklist[sindex].leader_nick_name}
    this.refs.taskModal.getWrappedInstance().loadTask({}, Object.assign(data[index].tasklist[sindex],{person:person,leader:leader}))
  }

  onDateChange(field,index,sindex,e) {
    let {data} = this.state
    // let date = data[index].tasklist[sindex][field]
    // if (date!==null) {
    //   date = data[index].tasklist[sindex][field].substring(0,10)
    //   data[index].tasklist[sindex][field] = date
    // } else {
    //   data[index].tasklist[sindex][field] = this.getToday()
    // }
    data[index].tasklist[sindex][field] = e
    this.setState({data:data},()=>{
      let postData = data[index].tasklist[sindex]
      let task_id = data[index].tasklist[sindex].bf_task_id
      this.onPMFixingTaskSave(task_id,postData)
    })
  }

  onTimeChange(field,index,sindex,e) {
    let {data} = this.state
    // let date = data[index].tasklist[sindex][field]
    // if (date!==null) {
    //   date = data[index].tasklist[sindex][field].substring(0,10)
    //   data[index].tasklist[sindex][field] = date+' '+e
    // } else {
    //   data[index].tasklist[sindex][field] = this.getToday()+' '+e
    // }  
    data[index].tasklist[sindex][field] = e
    this.setState({data:data},()=>{
      let postData = data[index].tasklist[sindex]
      let task_id = data[index].tasklist[sindex].bf_task_id
      this.onPMFixingTaskSave(task_id,postData)
    })
  }

  onRowAdd(index,number=1) {
    let {data} = this.state
    data[index].tasklist = data[index].tasklist.concat(this.newEmptyRow(number,index))
    this.setState({data:data},()=>{
      let postData = data[index].tasklist[data[index].tasklist.length-1]
      let task_id = ''
      this.onPMFixingTaskSave(task_id,postData,(bf_task_id)=>{
        data[index].tasklist[data[index].tasklist.length-1].bf_task_id = bf_task_id
        this.setState({data:data})
      })
    })
  }

  onRowDel(field,index,sindex) {
    let {data} = this.state
    // if (sindex===0&&data[index].tasklist.length===1) {
    //   data[index].tasklist[sindex].leader_id = ''
    //   data[index].tasklist[sindex].leader_first_name = ''
    //   data[index].tasklist[sindex].leader_last_name = ''
    //   data[index].tasklist[sindex].leader_nick_name = ''
    //   data[index].tasklist[sindex].employee_id = ''
    //   data[index].tasklist[sindex].first_name = ''
    //   data[index].tasklist[sindex].last_name = ''
    //   data[index].tasklist[sindex].nick_name = ''
    // } else {
    //   data[index].tasklist.splice(sindex,1)
    // }
    // this.setState({data:data})

    WorkdocStore.delPMFixingTask(data[index].tasklist[sindex].bf_task_id,(result)=>{
      if (result.status==='OK') {
        data[index].tasklist.splice(sindex,1)
        this.setState({data:data})
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการลบรายการสำเร็จ',
          level:'info',
          position:'tc'
        });
      }
    },()=>{
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำการลบรายการไม่สำเร็จ',
        level:'error',
        position:'tc'
      });
    })
  }

  onTaskRowDel(index) {
    let {data} = this.state
    data.splice(index,1)
    this.setState({data:data},()=>{
      let itemlist = []
      data.forEach((item,index)=>{
        item.tasklist.forEach((sitem,sindex)=>{
          itemlist.push(sitem)
        })
      })
      this.savePMTasklist(this.props.workNo,itemlist)
    })
  }

  onAssignTaskDelete(rid,_rid) {
      let {data} = this.state
      let bf_task_id = data[rid].tasklist[_rid].bf_task_id
      if (bf_task_id===''||bf_task_id===undefined||bf_task_id===null) {
        data[rid].splice(_rid, 1) 
        if (data[rid].tasklist.length<2) {
          data = data.map((item,index)=>{
            if (index===rid)
              return item.tasklist[item.length-1]
            else 
              return item  
          })
        }
        this.setState({ data: data, showAssign: false, assignIndex: -1, assignSubIndex: -1 })
      } else {
        this.setState({showTaskDelete:true,assignIndex:rid,assignSubIndex:_rid})
      }
  }

  onAssignTaskSave(jobData) {
    let {data,assignIndex,assignSubIndex} = this.state
    data[assignIndex].tasklist[assignSubIndex].employee_id = jobData.person.employee_id
    data[assignIndex].tasklist[assignSubIndex].first_name = jobData.person.first_name
    data[assignIndex].tasklist[assignSubIndex].last_name = jobData.person.last_name
    data[assignIndex].tasklist[assignSubIndex].nick_name = jobData.person.nick_name
    data[assignIndex].tasklist[assignSubIndex].leader_id = jobData.person.employee_id
    data[assignIndex].tasklist[assignSubIndex].leader_first_name = jobData.leader.first_name
    data[assignIndex].tasklist[assignSubIndex].leader_last_name = jobData.leader.last_name
    data[assignIndex].tasklist[assignSubIndex].leader_nick_name = jobData.leader.nick_name
    let postData = data[assignIndex].tasklist[assignSubIndex]
    let task_id = data[assignIndex].tasklist[assignSubIndex].bf_task_id
    this.onPMFixingTaskSave(task_id,postData,()=>{
      this.setState({showAssign:false,assignIndex:-1,assignSubIndex:-1,data:data})
    })  
  }

  onWhereFixClick(value) {
    this.setState({where_fix:value})
  }
  
  renderTdEmp(item,field,index,sindex) {
    let title = ''
    let displayDel = ''
    if (field==='leader') {
      if ((item.leader_first_name!==''&&item.leader_last_name!=='')&&(item.leader_first_name!==null&&item.leader_last_name!==null)&&(item.leader_first_name!==undefined&&item.leader_last_name!==undefined)) {
        title = item.leader_first_name+' '+item.leader_last_name
      } else {
        title = 'แก้ไขชื่อผู้มอบหมาย'
        if (sindex===0)
          displayDel = 'none'
      }
    } else {
      if ((item.first_name!==''&&item.last_name!=='')&&(item.first_name!==null&&item.last_name!==null)&&(item.first_name!==undefined&&item.last_name!==undefined)) {
        title = item.first_name+' '+item.last_name
      } else {
        title = 'แก้ไขชื่อผู้ปฎิบัติงาน'
      }
    }
    return(
      <div>
        <Button bsStyle='link' onClick={this.onTechnicianEdit.bind(this,index,sindex)}>
          <FontAwesome name='pencil' />{' '} {title}
        </Button>
        <div className="text-right" style={{position:'relative',cursor:'pointer',display:(field==='leader'?'':'none')}}>
          <span onClick={this.onRowAdd.bind(this,index,1)} className="fa fa-plus color-green" style={{display:(sindex===0?'':'none'),position:'absolute',bottom:'-35px',right:(displayDel==='none'?'0px':'30px')}}></span>
          <span onClick={this.onRowDel.bind(this,field,index,sindex)} className="fa fa-minus color-red" style={{display:displayDel,position:'absolute',bottom:'-35px',right:'0px'}}></span>
        </div>
      </div>
    )
  }

  renderDatePicker(item,field,index,sindex) {
    return (
      <DatePicker style={{ display: 'inline-block', minWidth: '160px' }}
        showIcon={true}
        showFooter={true}
        buddhistEra={true}
        popPlacement='bottom'
        value={item[field]===null?'':item[field]}
        onChange={this.onDateChange.bind(this,field,index,sindex)}
      />
    )
  }

  renderTimePicker(item,field,index,sindex) {
    return (
      <CkTimePicker
        value={item[field]===null?'':item[field]}
        onTimeSaved={this.onTimeChange.bind(this,field,index,sindex)}
      />
    )
  }

  renderTdDateTime(item,field,index,sindex) {
    return([
          <div style={{ display: 'table-row' }} key={'date'+index+sindex}>
            <div className='bt-td-left'>
              วันที่
            </div>
            <div className='bt-td-right text-center' style={{ width: '100%' }}>
              {this.renderDatePicker(item,(field==='start'?'taskstarted_date':'taskclosed_date'),index,sindex)}
            </div>
          </div>,
          <div style={{ display: 'table-row' }} key={'time'+index+sindex}>
            <div
              className='bt-td-left'
              style={{ borderBottom: '0' }}
            >
              เวลา
            </div>
            <div
              className='bt-td-right text-center'
              style={{ width: '100%', borderBottom: '0' }
            }>
              {this.renderTimePicker(item,(field==='start'?'taskstarted_time':'taskclosed_time'),index,sindex)}
            </div>
          </div>
    ])
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0)
      return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
    else {
      return(
        data.map((item,index)=> {
          return(
            item.tasklist.map((sitem,sindex)=>{
              return(
                <tr key={sindex}>
                  <td style={{display:(sindex===0?'':'none')}} rowSpan={item.tasklist.length} className='fit text-center'>{index+1}</td>
                  <td style={{display:(sindex===0?'':'none')}} rowSpan={item.tasklist.length} className='fit text-center'>
                    <Button bsStyle='link' onClick={()=>{}} style={{color:'#333'}}>
                      {sitem.task_value===''?'...':sitem.task_value}
                    </Button>
                    <div className="text-right" style={{position:'relative',cursor:'pointer'}}>
                      <span onClick={this.onTaskRowDel.bind(this,index)} className="fa fa-minus color-red" style={{position:'absolute',bottom:'-35px',right:'0px'}}></span>
                    </div>
                  </td>
                  <td className='fit text-center'>{this.renderTdEmp(sitem,'leader',index,sindex)}</td>
                  <td className='fit text-center'>{this.renderTdEmp(sitem,'technician',index,sindex)}</td>
                  <td className='fit text-center'>{this.renderTdDateTime(sitem,'start',index,sindex)}</td>
                  <td className='fit text-center'>{this.renderTdDateTime(sitem,'close',index,sindex)}</td>
                  <td className='fit text-left'>
                    <Select
                      clearable={false}
                      placeholder='สถานะ'
                      value={sitem.task_status}
                      options={[
                        {label:'รอช่าง, รออะไหล่',value:'01'},
                        {label:'รอช่าง, อะไหล่ครบ',value:'02'},
                        {label:'ช่างกำลังซ่อม, รออะไหล่',value:'03'},
                        {label:'ช่างกำลังรื้อถอด, อะไหล่ครบ',value:'04'},
                        {label:'ช่างกำลังประกับ',value:'05'},
                        {label:'ช่างกำลัง QC',value:'06'},
                        {label:'จบงาน',value:'07'}
                      ]}
                      onChange={this.onTaskStatusChange.bind(this,index,sindex)}
                    />
                  </td>
                </tr>
              )
            })
          )  
        })
      )
    }  
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid' style={{marginBottom:'0',minWidth:'1280px'}}>
          <thead>
            <tr>
              <th className='fit text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='fit text-center' style={{width:'200px'}}>รายการ/อาการเสีย/PM</th>
              <th className='fit text-center' style={{width:'120px'}}>มอบหมายให้</th>
              <th className='fit text-center' style={{width:'120px'}}>ผู้ปฎิบัติงาน</th>
              <th className='fit text-center' style={{width:'120px',minWidth:'120px'}}>เริ่ม</th>
              <th className='fit text-center' style={{width:'120px',minWidth:'120px'}}>เลิก</th>
              <th className='fit text-center' style={{width:'150px',minWidth:'150px'}}>สถานะงาน</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>
    )
  }

  onSymptomClick() {
    this.setState({showSymptom:true})
  }

  onSymptomClose() {
    this.setState({showSymptom:false})
  }

  onSymptomAllChange(value) {
    let {symptomlist} = this.state
    symptomlist.forEach((item,index)=>{
      this.onSymptomChange(value,index)
    })
    this.setState({isCheckAll:value})
  }

  onSymptomChange(value,index) {
    let {symptomlist} = this.state
    symptomlist[index].isCheck = value
    let checkAll = true
    symptomlist.forEach((item,index)=>{
      if (!item.isCheck)
        checkAll = false  
    })
    this.setState({symptomlist:symptomlist,isCheckAll:checkAll})
  }

  onSaveClick() {
    let {workNo} = this.props
    let {symptomlist} = this.state
    let pullItemlist = this.pullItemlist(symptomlist,'SYMPTOM')
    this.savePMTasklist(workNo,pullItemlist)
  }

  pullItemlist(newItem,field) {
    // let {data} = this.state
    let itemlist = []
    // data.forEach((item,index)=>{
    //   item.tasklist.forEach((sitem,sindex)=>{
    //     itemlist.push(sitem)
    //   })
    // })
    newItem.forEach((item,index)=>{
      if (item.isCheck||field==='PM') {
        itemlist.push({
          bf_symptom_id:(field==='PM'?item.bf_work_program_id:item.bf_symptom_id),
          bf_task_id:'',
          contractor_id:'',
          employee_id:'',
          first_name:'',
          last_name:'',
          leader_first_name:'',
          leader_id:'',
          leader_last_name:'',
          leader_nick_name:'',
          nick_name:'',
          remark:'',
          seq:'',
          task_status:'',
          task_value:item.detail,
          taskclosed_date:'',
          taskclosed_time:'',
          taskstarted_date:'',
          taskstarted_time:'',
          total_cost:'',
          work_no:(field==='PM'?this.props.workNo:item.work_no)
        })
      }  
    })
    return itemlist
  }

  onPMClick() {
    this.setState({showProgram:true})
  }

  onProgramSelect(wageItem,partItem,program) {
    let pullItemlist = this.pullItemlist(wageItem,'PM')
    this.savePMTasklist(this.props.workNo,pullItemlist)
  }

  savePMTasklist(workNo,itemlist) {
    let postData = {wo:workNo,task:itemlist}
    WorkdocStore.savePMTasklist(postData,(result)=>{
      if (result.status==='OK') {
        this.setState({showSymptom:false},()=>{
          this.loadData()
        })
        this._notificationSystem.addNotification({
          title:'แจ้งเตือน',
          message:'ทำการบันทึกรายการสำเร็จ',
          level:'info',
          position:'tc'
        });
      }
    },()=>{
      this.setState({showSymptom:false})
      this._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำการบันทึกรายการไม่สำเร็จ',
        level:'error',
        position:'tc'
      });
    })
  }

  renderNewItemButton(){
    return(
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <div className='new-item-btn' style={{display:'inline-flex'}}>
            <Button bsStyle='primary' onClick={this.onSymptomClick.bind(this)}><FontAwesome name='search' />&nbsp;ดึงรายการอาการ</Button>&nbsp;
            <Button bsStyle='warning' onClick={this.onPMClick.bind(this)}><FontAwesome name='search'/>&nbsp;ดึงรายการ PM</Button>
          </div>        
        </Col>
      </Row>
    )
  }

  renderSymptomRowData() {
    let {symptomlist} = this.state
    if (symptomlist.length===0) {
      return(<tr><td colSpan={4}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        symptomlist.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>
                <Checkbox
                  onChange={this.onSymptomChange.bind(this,(item.isCheck?false:true),index)}
                  checked={item.isCheck}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label=""
                >
                </Checkbox>
              </td>
              <td className='text-center'>{item.category}</td>
              <td className='text-left'>{item.detail}</td>
              <td className='text-center'>{item.level}</td>
            </tr>
          )
        })
      )
    }
  }

  renderSymptom() {
    let {showSymptom,isCheckAll} = this.state
    return(
      <div>
        <Modal onShow={this.loadSymptom.bind(this)} bsSize="large" show={showSymptom} onHide={this.onSymptomClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>เลือกรายการอาการ</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='table-responsive'>
              <table className='table table-hover table-bordered-solid'>
                <thead>
                  <tr>
                    <th className='text-center' style={{width:'50px'}}>
                      <Checkbox
                        onChange={this.onSymptomAllChange.bind(this,(isCheckAll?false:true))}
                        checked={isCheckAll}
                        checkboxClass="icheckbox_square-blue"
                        increaseArea="20%"
                        label=""
                      >
                      </Checkbox>
                    </th>
                    <th className='text-center' style={{width:'100px'}}>หมวดหมู่</th>
                    <th className='text-center' style={{width:'150px'}}>รายละเอียดอาการ</th>
                    <th className='text-center' style={{width:'100px'}}>ระดับความแรง</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderSymptomRowData()}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className='pull-right'>
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
              <Button onClick={this.onSymptomClose.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
            </div>
          </Modal.Footer>
        </Modal>    
      </div>
    )
  }

  render() {
    let {loading,showAssign,where_fix} = this.state
    return (
      <div>
        <Box loading={loading}>
          <Box.Body>
            <div>
              <Form horizontal>
                <FormGroup>
                  <Col sm={1}>เลขใบจ็อบ</Col>
                  <Col sm={5}>{this.props.workNo}</Col>
                </FormGroup>
                <FormGroup>
                  <Col sm={1}>วันที่สร้างจ็อบ</Col>
                  <Col sm={5}>12/11/2562</Col>
                </FormGroup> 
                <FormGroup>
                  <Col sm={1}>สถานที่ซ่อม</Col>
                  <Col sm={5}>
                    <Radio
                      onChange={this.onWhereFixClick.bind(this,'in')}
                      checked={where_fix==='in'?true:false}
                      radioClass="iradio_square-blue"
                      increaseArea="20%"
                      label=" ในอู่"
                    >
                    </Radio>
                    {' '}
                    <Radio
                      onChange={this.onWhereFixClick.bind(this,'out')}
                      checked={where_fix==='out'?true:false}
                      radioClass="iradio_square-blue"
                      increaseArea="20%"
                      label=" นอกอู่"
                    >
                    </Radio>
                    {' '}
                    <Radio
                      onChange={this.onWhereFixClick.bind(this,'other')}
                      checked={where_fix==='other'?true:false}
                      radioClass="iradio_square-blue"
                      increaseArea="20%"
                      label=" อู่นอก"
                    >
                    </Radio>
                  </Col>
                  <Col style={{paddingTop:'0'}} className='text-right' sm={6}>
                    <Button                       
                      bsStyle={'success'}
                      onClick={()=>{}}
                    >
                      <FontAwesome name='check-square-o'/>&nbsp;ปิดจ็อบ
                    </Button>
                  </Col>
                </FormGroup> 
              </Form>
              {this.renderTable()}
              {this.renderNewItemButton()}
            </div>
          </Box.Body>
        </Box>
        <NotificationSystem ref="notificationSystem" />
        <WorkJobAssignTaskModal 
          jobType='pmcontrol'
          ref='taskModal' 
          show={showAssign} 
          title={'ผู้รับผิดชอบงาน'}
          showTask={false}
          showLeader={true}
          onDelete={this.onAssignTaskDelete.bind(this)}
          onSave={this.onAssignTaskSave.bind(this)}
          onHide={()=>{this.setState({showAssign:false,assignIndex:-1,assignSubIndex:-1}) }} 
        />
        {this.renderSymptom()}
        <SWTProgramPopup 
          ref={'programPopup'} 
          show={this.state.showProgram} 
          workNo={this.props.workNo}
          onSelect={this.onProgramSelect.bind(this)} 
          onHide={()=>{this.setState({showProgram:false})}}
        />
      </div>
    )
  }
}

PMBoardTable.defaultProps = {
  
}

export default connect(
  (state) => ({messages: state.message.view.workdoc.pmcontrol.PMBoardTable}),null,null,{withRef:true},
)(PMBoardTable);


// WEBPACK FOOTER //
// ./src/view/workdoc/pmcontrol/PMBoardTable.js